import React from 'react'
import { SearchPanelFilterPill } from '@Components/Search/SearchPanel/types'
import FilterPill from '@Components/Search/SearchPanel/FilterPill'

interface FilterPillsProps {
    activeFilterPills: SearchPanelFilterPill[]
}

const FilterPills = ({ activeFilterPills }: FilterPillsProps) => {
    if (activeFilterPills.length === 0) {
        return null
    }
    return (
        <div className="active-filter-pills">
            {activeFilterPills.map((pill) => (
                <FilterPill key={pill.key} filterPill={pill} />
            ))}
        </div>
    )
}

export default FilterPills
